// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"errorPage__2KHGw","image":"image__1WUik","content":"content__2mWkL","container":"container__3x9Jr","title":"title__3vXT6","text":"text__1uGu9"};